import { BUSINESS_SEARCH_INPUT_OPTIONS } from '~services/constant/business';
import HelperOptions from '~component/helper/helper-options';

// 搜索商机的输入框，对应的字段类型
export default {
  functional: true,
  render(createElement, context) {
    const { data } = context;

    return (
      <HelperOptions
        { ...data }
        options={ BUSINESS_SEARCH_INPUT_OPTIONS }
      />
    );
  },
};
